import { addCoreFollowedIdMapSlice } from './add';
import { removeCoreFollowedIdMapSlice } from './remove';

export const addFollowed = addCoreFollowedIdMapSlice.syncActionCreator;
export const removeFollowed = removeCoreFollowedIdMapSlice.syncActionCreator;
